import axios from 'axios';
import {
	Message
} from 'element-ui';
import Cookies from 'js-cookie'
let baseUrl = 'https://api.mfcad.cn/';
let baseUrlCN = 'https://api.mfcad.cn/';
// axios.defaults.timeout = 5000;
axios.defaults.baseURL = '';
let Usercookie = '';
axios.defaults.headers = {
	'Partscookie': Cookies.get('mf_service_ticket'),
	'Content-Type': 'application/json; charset=utf-8',
}
//http request 拦截器
axios.interceptors.request.use(
	config => {
		config.data = JSON.stringify(config.data);
		if (Cookies.get('mf_service_ticket')) {
			let AUTH_TOKEN = Cookies.get('token');
			config.headers = {
				//'Authorization': AUTH_TOKEN,
				'Content-Type': 'application/json; charset=utf-8',
				'Partscookie': Cookies.get('mf_service_ticket'),
			}
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);
//http response 拦截器
axios.interceptors.response.use(
	response => {
		// console.log(response.data.Message)
		//  if(!response.data.Success){
		//    Message(response.data.Message)
		//  }
		return response;
	},
	error => {
		return Promise.reject(error)
	}
)
export default axios
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data, t) {
	return new Promise((resolve, reject) => {
		axios.post(baseUrl + url, data, t)
			.then(response => {
				//console.log(response)
				resolve(response);
			}, err => {
				reject(err)
			})
	})
}
export function postcn(url, data, t) {
	return new Promise((resolve, reject) => {
		axios.post(baseUrlCN + url, data, t)
			.then(response => {
				//console.log(response)
				resolve(response);
			}, err => {
				reject(err)
			})
	})
}



// WEBPACK FOOTER //
// ./src/utils/loginGlobal.js